import CustomCheckboxGroup from 'designer/component/element/CheckboxGroup'

const CheckboxGroupControl = (props) => {
  const { uischema, handleChange, path, config } = props
  const data = config?.jsonData

  const updateInput = ({ input = {} }, value) => {
    updateValue(input, value)
  }

  const updateValue = ({ name }, value) => {
    handleChange(name, value)
  }

  return (
    <CustomCheckboxGroup
      {...props}
      uischema={uischema}
      data={data}
      updateCheckbox={updateValue}
      updateInput={updateInput}
      uiKey={uischema.key}
    />
  )
}

export default CheckboxGroupControl
